import { useState } from 'react';
import { fetchAdviseInvoiceFile } from '../../../../Api/Advise/Engagements';
import { AdviseSupplierInvoice } from '../../../../types/advise';
import { TextSpan } from '../../../Atoms/Text';
import { TextButton } from '../../../Atoms/TextButton';
import { downloadFromUrl } from '../../../../utils/fileDownload';

export interface InvoiceFileProps {
  engagementId: string;
  supplierId: string;
  invoice: AdviseSupplierInvoice;
}

const DOWNLOAD_FAILED = "Couldn't download the invoice. Please try again.";

// Every Download reads links of its own: the preview's may have expired, and the browser's clock can't be trusted to
// say so, while new ones in the preview would send it back to page 1.
const useInvoiceDownload = ({ engagementId, supplierId, invoice }: InvoiceFileProps) => {
  const [failed, setFailed] = useState(false);
  const [downloading, setDownloading] = useState(false);
  const download = async () => {
    if (downloading) return;
    setDownloading(true);
    setFailed(false);
    const { data } = await fetchAdviseInvoiceFile(engagementId, supplierId, invoice.id);
    setDownloading(false);
    if (data) downloadFromUrl(data.download_url, invoice.file_name);
    else setFailed(true);
  };
  return { download, downloading, failed };
};

/** Download, which reads new links for each click, saying so beside it when the file can't be downloaded. */
export const InvoiceDownloadButton = (props: InvoiceFileProps) => {
  const { download, downloading, failed } = useInvoiceDownload(props);
  return (
    <div className="flex items-center justify-end gap-2">
      {failed && (
        <TextSpan
          size="xs"
          color="red">
          {DOWNLOAD_FAILED}
        </TextSpan>
      )}
      <TextButton
        disabled={downloading}
        onClick={download}>
        Download
      </TextButton>
    </div>
  );
};
